import { BlobClient } from '@azure/storage-blob';

export interface AzureBlobStorage {
  blob: BlobClient;
}

export interface AzureBlobStorageParam {
  name: string;
  path?: string;
  token?: string;
  file?: Blob;
  timestamp?: string;
  container? : String;
}

export interface PowerPanelServiceParam{
  code: string;
  path: string;
}

export interface ResponseInfo{
  Flag: boolean;
  Message: string;
  ExtMsg?: string;
}
